import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

/** Hover/focus hint for grid cells. `children` is the trigger and must be a single focusable-friendly element. */
export function HintTip({ content, children }: { content: ReactNode; children: ReactNode }) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="max-w-64 text-xs">{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
